import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseTableService } from '../base-tables/base-table.service';
import { ITopic } from '../base-tables/topic';
import { IMetricCost } from './metric-cost';
import { IMetricCountyCount } from './metric-county-count';
import { IMetricRequest } from './metric-request';
import { MetricService } from './metric-service';
import { IMetricStatusCount } from './metric-status-count';
import { CALL_TRACKER } from '@shared/utils/app-static-data';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss']
})
export class MetricsComponent implements OnInit {
  public uiData = CALL_TRACKER;
  statusCounts: IMetricStatusCount = {
    closed: 0,
    open: 0,
    total: 0
  };
  costs: IMetricCost[] = [];
  countyCounts: IMetricCountyCount[] = [];
  primaryTopics: ITopic[] = [];
  secondaryTopics: ITopic[] = [];
  tertiaryTopics: ITopic[] = [];

  statusForm = new FormGroup({
    from: new FormControl(null),
    to: new FormControl(null),
    programId: new FormControl(0),
    topicId: new FormControl(0),
    secondTopicId: new FormControl(0),
    tertiaryTopicId: new FormControl(0)
  });

  costForm = new FormGroup({
    from: new FormControl(null),
    to: new FormControl(null),
    programId: new FormControl(0),
    topicId: new FormControl(0),
    secondTopicId: new FormControl(0),
    tertiaryTopicId: new FormControl(0)
  });

  countyForm = new FormGroup({
    from: new FormControl(null),
    to: new FormControl(null),
    programId: new FormControl(0),
    topicId: new FormControl(0),
    secondTopicId: new FormControl(0),
    tertiaryTopicId: new FormControl(0)
  });

  universalUpdateForm = new FormGroup({
    from: new FormControl(null),
    to: new FormControl(null)
  });

  constructor(private metricService: MetricService, public baseService: BaseTableService) {
    if(!this.baseService.lookupsLoaded){
      this.baseService.setup();
    }
   }

  ngOnInit(): void {
    this.getAllMetrics();
    const checkLookupsLoaded = setInterval(() => {
      if(this.baseService.lookupsLoaded) {
        this.primaryTopics = this.baseService?.topics?.filter(topic => topic.topicId == topic.parentId);
        clearInterval(checkLookupsLoaded);
      }
    }, 100);
  }

  getStatusMetrics() {
    let request: IMetricRequest = this.getMetricRequest('status');
    this.metricService.getStatusCounts(request).subscribe(
      response => this.statusCounts = response,
      error => console.log('error', error)
    );
  }

  getCostMetrics() {
    let request: IMetricRequest = this.getMetricRequest('cost');
    this.metricService.getCosts(request).subscribe(
      response => this.costs = response,
      error => console.log('error', error),
      () => this.costs = this.costs.filter(cost => cost.cost > 0)
    );
  }

  getCountyMetrics() {
    let request: IMetricRequest = this.getMetricRequest('county');
    this.metricService.getCountyCounts(request).subscribe(
      response => this.countyCounts = response,
      error => console.log('error', error)
    );
  }

  getMetricRequest(type: string): IMetricRequest {
    let requestForm = type === 'status' ? this.statusForm.value : type === 'cost' ? this.costForm.value : this.countyForm.value;    
    let request:IMetricRequest = {
      from: requestForm.from !== '' ? requestForm.from : null,
      to: requestForm.to !== '' ? requestForm.to : null,
      programId: Number(requestForm.programId),
      topicId: Number(requestForm.topicId),
      secondTopicId: Number(requestForm.secondTopicId),
      tertiaryTopicId: Number(requestForm.tertiaryTopicId)
    };
    return request;
  }

  updateAll() {
    this.statusForm.patchValue({
      from: this.universalUpdateForm.value.from,
      to: this.universalUpdateForm.value.to
    });

    this.costForm.patchValue({
      from: this.universalUpdateForm.value.from,
      to: this.universalUpdateForm.value.to
    });

    this.countyForm.patchValue({
      from: this.universalUpdateForm.value.from,
      to: this.universalUpdateForm.value.to
    });

    this.getAllMetrics();
  }

  getAllMetrics() {
    this.getStatusMetrics();
    this.getCostMetrics();
    this.getCountyMetrics();
  }

  updateSecondaryTopics(topicId: string) {
    this.secondaryTopics = [];
    this.tertiaryTopics = [];
    this.costForm.controls.secondTopicId.patchValue(0);
    this.costForm.controls.tertiaryTopicId.patchValue(0);
    this.secondaryTopics = this.baseService.topics.filter(topic => topic.parentId === Number(topicId) && topic.parentId !== topic.topicId);
  }

  updateTertiaryTopics(secondaryId: string) {
    this.tertiaryTopics = [];
    this.costForm.controls.tertiaryTopicId.patchValue(0);
    this.tertiaryTopics = this.baseService.topics.filter(topic => topic.parentId === Number(secondaryId) && topic.parentId !== topic.topicId);
  }
}
